import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Grid } from '../grid/Grid';

import './section.css';

export default class Section extends Component {
  renderContent({ headline, children }) {
    return (
      <div>
        {headline ? <h2 className="section-title">{headline}</h2> : null}
        {children}
      </div>
    );
  }

  renderGrid() {
    const { noGrid, ...rest } = this.props;
    if (!noGrid) {
      return <Grid fluid={this.props.fluid}>{this.renderContent(rest)}</Grid>;
    }
    return this.renderContent(rest);
  }

  render() {
    const { border, highlight, small, className } = this.props;
    return (
      <section className={classNames('section', { border, highlight, small }, className)}>
        {this.renderGrid()}
      </section>
    );
  }
}

Section.propTypes = {
  headline: PropTypes.string,
  border: PropTypes.bool,
  highlight: PropTypes.bool,
  fluid: PropTypes.bool,
  noGrid: PropTypes.bool,
  small: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
};
